import { useClient } from "@/hooks/useClient";

export default function HomeHeader() {
  const { client } = useClient();
  const firstName = client?.name?.split(" ")[0] ?? "bienvenida";

  return (
    <header className="px-5 pb-4 pt-6">
      <div className="min-w-0">
        <p className="font-label text-[10px] font-bold uppercase tracking-[0.28em] text-accent-700">
          ALÉA Club
        </p>
        <h1 className="mt-1 truncate font-heading text-xl font-extrabold text-foreground-950">
          Hola, {firstName}
        </h1>
        <p className="mt-0.5 text-xs text-foreground-600">Tu ritual de piel empieza aquí.</p>
      </div>
    </header>
  );
}
